import React from 'react';
import PropTypes 	from 'prop-types';

export default class SearchListingItem extends React.Component
{
	constructor(props) 
	{
		super(props);
	}

	render() 
	{
		const {classes = '', item} = this.props;

		return (
			<li className="search-listing-item">
				<a href={item.url} className="search-listing-item__internal">
					<div className="search-listing-item__image">
						<img className="search-listing-item__image-item" src={item.image}/>
					</div>
					<div className="search-listing-item__details">
						<strong className="search-listing-item__name">{item.name}</strong>
						{item.meta ? 
							<p className="search-listing-item__meta" dangerouslySetInnerHTML={{__html: item.meta}}/>
						: null}
					</div>
				</a>
			</li>
		);
	}

	static getDataFromItemColor( dmItemColor )
	{
		let	colorInfo	= dmItemColor > 0 ? blapp.color.get( dmItemColor.idColor ) : null;

		var	item	= 
			{
				image:	blapp.url2.getCatalogItemImgUrl( dmItemColor.dmImg, "T1" )
			,	url:	blapp.url2.getCatalogItemPageUrl( dmItemColor.dmItem, dmItemColor.idColor )
			,	name:	( colorInfo ? colorInfo.strColorName + " " : "" ) + "[" + dmItemColor.dmItem.strItemNoFull + "] " + dmItemColor.dmItem.strItemName
			}

		return item;
	}
}

SearchListingItem.propTypes = 
{
		classes: PropTypes.string
	,	item: PropTypes.shape({
			name: PropTypes.string.isRequired
		,	url: PropTypes.string.isRequired
		,	image: PropTypes.string.isRequired
		, meta: PropTypes.string	
	}).isRequired
	, theme: PropTypes.oneOf(['dark', 'light'])
}